export default __webpack_public_path__ + "static/media/background.7f3cd50e.png";